// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import WarrantyFormState from "@store/Framework/Store/Store/Components/WarrantyForm/WarrantyFormState";
import { Draft } from "immer";

const initialState: WarrantyFormState = {
    fieldValues: {},
};

const reducer = {
    "Components/WarrantyForm/ClearForm": (draft: Draft<WarrantyFormState>) => {
        draft.fieldValues = {};
    },
    "Components/WarrantyForm/SetFieldValue": (
        draft: Draft<WarrantyFormState>,
        action: { key: string; value: string },
    ) => {
        draft.fieldValues[action.key] = action.value;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
